import { Button } from "@progress/kendo-react-buttons";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  ItemActiveInactive,
  deleteItem,
  getAllItem,
} from "./services/item.services";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  clearItemID,
  clearItemDetail,
  setItemID,
  setFilterItem,
  clearFilterItem,
} from "./itemSlice";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";
import {
  HeaderThElement,
  // PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import IconButton from "../../components/common/IconButton";
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Switch } from "@progress/kendo-react-inputs";
import { LoadingPanel } from "../../components/layout/Loading";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";

const Item: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    return () => {
      dispatch(setCurrentPage(0));
      dispatch(closeDialog());
      dispatch(clearItemDetail());
      dispatch(clearFilterItem());
    };
  }, []);

  const handleItemCreate = () => {
    navigate("/item/create");
  };

  return (
    <>
      <DeleteItemDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Product List
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handleItemCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              Add New
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <ItemGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const ItemGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const ItemList = useAppSelector((state) => state.item.ItemList);
  const loading = useAppSelector((state) => state.item.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const FilterItem = useAppSelector((state) => state.item.FilterItem);
  useEffect(() => {
    const payload = {
      ...FilterItem,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllItem(payload));
  }, [currentPage, pageLimit]);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const MyEditCommandCell = (props: any) => {
    const handleEditItem = (ID: number) => {
      navigate("/item/edit", {
        state: { item_guid: ID, id: props.dataItem?.id },
      });
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteItem"));
      dispatch(setItemID(ID));
    };
    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            themeColor="success"
            onClick={() => handleEditItem(props.dataItem.item_guid)}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() => handleOpenDeleteDialog(props.dataItem.item_guid)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 5 || props.index === 6 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );
  const MyActiveInActtiveCommandCell = (props: any) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem?.isactive);

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        item_guid: props.dataItem.item_guid,
        isactive: !IsActive,
      };
      dispatch(ItemActiveInactive(data)).then((response: any) => {
        const payload = {
          ...FilterItem,
          limit: +pageLimit,
          skip: +currentPage * +pageLimit,
        };
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllItem(payload));
        } else {
          dispatch(getAllItem(payload));
        }
      });
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style, textAlign: "center" }}
      >
        <Tooltip anchorElement="target" position="top" parentTitle={true}>
          <div title={`Set ${IsActive ? "Inactive" : "Active"}.`}>
            <Switch
              disabled={isEditAccess ? false : true}
              name="isactive"
              checked={IsActive}
              onChange={handleActiveInActive}
              size="small"
            />
          </div>
        </Tooltip>
      </td>
    );
  };

  const ItemFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) => state.item.FilterItem}
        setFilterAction={setFilterItem}
        clearFilterAction={clearFilterItem}
        fetchDataAction={getAllItem}
        pagination={{ case: "lowercase" }}
      />
    ),
    []
  );

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        scrollable="scrollable"
        className="responsive-table"
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        filter={filter}
        data={filter ? filterBy(ItemList, filter) : ItemList}
        total={ItemList[0]?.itemcount || ItemList.length}
        onFilterChange={handleFilterChange}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          width={250}
          field="item_name"
          title="Product Name"
          cells={{
            data: (props: any) => (
              <td>
                <div
                  className="hoverableName"
                  onClick={() =>
                    navigate("/item/edit", {
                      state: { item_guid: props.dataItem?.item_guid },
                    })
                  }
                >
                  {props.dataItem?.item_name}
                </div>
              </td>
            ),
            filterCell: ItemFilterCell,
          }}
        />
        {/* <Column
          field="item_nick_name"
          title="Product Nick Name"
          width={170}
          cells={{ filterCell: ItemFilterCell }}
        /> */}
        <Column
          field="item_id"
          title="Product ID"
          width={170}
          cells={{ filterCell: ItemFilterCell }}
        />
        <Column
          field="category_name"
          title="Product Category"
          width={200}
          cells={{ filterCell: ItemFilterCell }}
        />
        <Column
          field="item_subcategory_name"
          title="Product Sub Category"
          width={190}
          cells={{ filterCell: ItemFilterCell }}
        />
        <Column
          field="isactive"
          title="Status"
          cells={{ data: MyActiveInActtiveCommandCell }}
          width={"90px"}
          filterable={false}
          locked={true}
        />
        {(isDeleteAccess || isEditAccess) && (
          <Column
            field="item_guid"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"110px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeleteItemDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const ItemID = useAppSelector((state) => state.item.ItemCategoryID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterItem = useAppSelector((state) => state.item.FilterItem);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteItem(ID));
      dispatch(setCurrentPage(0));
      const payload = {
        ...FilterItem,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload?.Data.Status === 200) {
        dispatch(getAllItem(payload));
        dispatch(closeDialog());
        dispatch(clearItemID());
      } else {
        dispatch(getAllItem(payload));
        dispatch(closeDialog());
        dispatch(clearItemID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteItem" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Product ?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Product?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => {
                    handleDeleteAction(ItemID);
                  }}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Item;
